var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_134197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8428 18.7969L23.9532 16.0016L32 29.2058L27.0307 26.6421L26.8896 32.001L18.8428 18.7969Z",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1571 18.7969L8.04675 16.0016L-1.55454e-05 29.2058L4.96921 26.6421L5.11037 32.001L13.1571 18.7969Z",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 14.668,
    rx: 12,
    ry: 12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRank);
export default __webpack_public_path__ + "static/media/icon-rank.a53b93c30ff00c778fec3d1bd3461de1.svg";
export { ForwardRef as ReactComponent };